import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { T, btnGhost, btnPrimary } from "../shared/theme";

/**
 * Страница 404 — рендерится внутри AuthenticatedLayout, поэтому сайдбар
 * остаётся на месте и пользователю есть куда уйти.
 *
 * Неавторизованный сюда не попадёт: RequireStaff на layout-роуте отправит
 * его на /auth/login раньше, чем отрисуется потомок.
 */
export default function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.box}>
        <div style={styles.code}>404</div>
        <div style={styles.title}>Страница не найдена</div>
        <div style={styles.subTitle}>
          Такого раздела нет. Возможно, ссылка устарела или в адресе опечатка.
        </div>

        <div style={styles.path} title={location.pathname}>
          {location.pathname}
        </div>

        <div style={styles.actions}>
          <button type="button" style={btnPrimary} onClick={() => navigate("/")}>
            На главную
          </button>
          <button type="button" style={btnGhost} onClick={() => navigate(-1)}>
            Назад
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px",
    background: T.bg,
    color: T.text,
  },
  box: {
    maxWidth: 520,
    textAlign: "center",
  },
  code: {
    fontSize: 72,
    fontWeight: 800,
    lineHeight: 1,
    color: T.accent,
  },
  title: {
    marginTop: 12,
    fontSize: 20,
    fontWeight: 800,
  },
  subTitle: {
    marginTop: 8,
    fontSize: 13,
    color: T.textMuted,
  },
  path: {
    marginTop: 16,
    padding: "8px 12px",
    borderRadius: T.r.md,
    border: `1px solid ${T.border}`,
    background: T.card,
    color: T.textDim,
    fontSize: 12,
    // Длинный путь не должен растягивать карточку.
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  actions: {
    marginTop: 24,
    display: "flex",
    gap: 10,
    justifyContent: "center",
  },
};
